import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'rewardCenterDetail',
  state: {
    rankListTotal: 0,
    rankList: [
      {
        index: 1,
        name: '王*雪',
        orderCount: 54654,
        isCurr: false
      },
      {
        index: 2,
        name: '王*力',
        orderCount: 123123,
        isCurr: true
      },
      {
        index: 3,
        name: '*心',
        orderCount: 123123,
        isCurr: false
      }
    ]
  },
  effects: {
    * getActivityDetail ({ payload }, { call, put }) {
      const res = yield call(service.getActivityDetail, payload)
      return res.data
    },
    * getBonus ({ payload }, { call, put }) {
      const res = yield call(service.getBonus, payload)
      return res.data
    },
    * getRankList ({ payload }, { call, put }) {
      const res = yield call(service.getRankList, payload)
      const { data: bizRes } = res
      if (bizRes.status !== HTTP_CODE.success) {
        Toast.fail(bizRes.err)
        throw new Error(bizRes.err)
      }
      return bizRes
    },
    * queryForAppDetail ({ payload }, { call, put }) {
      const res = yield call(service.queryForAppDetail, payload)
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
